import { BooleanInput, Button, useNotify, useRecordContext, useRefresh } from "react-admin";
import DescriptionIcon from "@mui/icons-material/Description";
import FormModal from "server/components/Modals/FormModal";
import dataProvider from "server/dataProvider";
import { erasmusRequests } from "api/erasmusApi";

// The only application field still editable after status Closed — no isClosed gate here, unlike
// EditTransportDialog.
const EditFinalReportDialog = () => {
  const record = useRecordContext();
  const notify = useNotify();
  const refresh = useRefresh();

  const handleConfirm = async data => {
    await dataProvider.customRequest(
      erasmusRequests.updateApplicationFinalReport(record?.id),
      { finalReportSubmitted: !!data.finalReportSubmitted },
      "PUT",
    );
    notify("Финалният отчет е обновен успешно", { type: "success" });
    refresh();
  };

  return (
    <FormModal
      titleContent="Редакция на финален отчет"
      onConfirm={handleConfirm}
      defaultValues={{ finalReportSubmitted: !!record?.finalReportSubmitted }}
      triggerButton={
        <Button
          variant="contained"
          color="inherit"
          size="medium"
          startIcon={<DescriptionIcon />}
          label="Редакция на финален отчет"
        />
      }
    >
      <BooleanInput
        source="finalReportSubmitted"
        label="Подаден финален отчет"
      />
    </FormModal>
  );
};

export default EditFinalReportDialog;
